import { ContentType as GeneratedContentType } from "../generated/gateway-client";
import { ContentType } from "./ContentType";

export const mapContentType = (contentType: ContentType): GeneratedContentType => {
  switch(contentType) {
    case ContentType.EventPost:
      return GeneratedContentType.EventPost;

    case ContentType.NewsPost:
      return GeneratedContentType.NewsPost;

    default:
      throw new Error("Unknown content type");
  }
}
